import { render, staticRenderFns } from "./F10Stock.vue?vue&type=template&id=268e617a&scoped=true"
import script from "./F10Stock.vue?vue&type=script&lang=js"
export * from "./F10Stock.vue?vue&type=script&lang=js"
import style0 from "./F10Stock.vue?vue&type=style&index=0&id=268e617a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268e617a",
  null
  
)

export default component.exports